import { createBrowserHistory } from "history";
import React from "react";
import { toast } from "react-toastify";

const AuthGuard = (Component) => {
  const history = createBrowserHistory();
  const isAuthenticated = true;

  return (props) => {
    if (isAuthenticated) {
      return <Component {...props} />;
    } else {
      history.push("/");
      return null;
    }
  };
};

export default AuthGuard;




export const handleError = (error) => {
  // if (error.response?.data) {
  //   const errorData = error.response?.data;
  //   Object.keys(errorData).forEach(key => {
  //     const errorMessage = errorData[key];
  //     console.log("errorMessage",errorMessage)
  //     if (Array.isArray(errorMessage)) {
  //       errorMessage.forEach(message => {
  //         toast.error(message);
  //       });
  //     } else {
  //       toast.error(`${errorMessage}`);
  //     }
  //   });
  // } else {
  //   toast.error('An unexpected error occurred. Please try again later.');
  // }

  if (error.response?.data) {
    const errorData = error.response?.data;
    Object.keys(errorData).forEach(key => {
      const errorMessage = errorData[key];
      console.log("errorMessage", errorMessage);

      // Check if the error message is related to date format
      if (Array.isArray(errorMessage)) {
        errorMessage.forEach(message => {
          // if (message && message?.toLowerCase().includes("date") && message && message.toLowerCase().includes("format")) {
          //   toast.error("Please give the date.");
          // } else {
          //   toast.error(message);
          // }
          if (typeof message === "string") {
            if (message.toLowerCase().includes("date") && message.toLowerCase().includes("format")) {
              toast.error("Please give the date.");
            } else {
              toast.error(message);
            }
          } else {
            toast.error(JSON.stringify(message));
          }
        });
      } else {
        // if (errorMessage.toLowerCase().includes("date") && errorMessage.toLowerCase().includes("format")) {
        //   toast.error("Please give the date.");
        // } else {
        //   toast.error(`${errorMessage}`);
        // }

        if (typeof errorMessage === "string") {
          if (errorMessage.toLowerCase().includes("date") && errorMessage.toLowerCase().includes("format")) {
            toast.error("Please give the date.");
          } else {
            toast.error(errorMessage);
          }
        } else {
          toast.error(JSON.stringify(errorMessage));
        }
      }
    });
  } else {
    toast.error('An unexpected error occurred. Please try again later.');
  }

};

